import type { ComponentType, ReactNode } from 'react';

import { cn } from '@/lib/cn';

/** Centered "nothing here" message — vervangt `.empty-note`. */
export function EmptyState({
  icon: Icon,
  text,
  action,
  className,
}: {
  /** A `lucide-react` icon component, rendered at 32px in `green` (accent). */
  icon?: ComponentType<{ className?: string }>;
  text: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-col items-center gap-3 py-10 text-center', className)}>
      {Icon && <Icon className="text-accent size-8" />}
      <p className="text-accent text-sm">{text}</p>
      {action}
    </div>
  );
}
